import { locale } from '../lib/locale';

/**
 * The frame of the app (1.19): navigation, page titles, header, person menu, update notice,
 * loading and "not found". German is the master; English has the same keys. Terms as on the
 * website: Aufgaben = Tasks, Freizeit = Fun (glossary 12.10.).
 */
export const APP_TEXT = {
  de: {
    nav: {
      today: 'Heute',
      calendar: 'Kalender',
      tasks: 'Aufgaben',
      food: 'Essen',
      stars: 'Sterne',
      fun: 'Freizeit',
    },
    titles: {
      settings: 'Einstellungen',
      feedback: 'Feedback',
      ideas: 'Ideen',
      vouchers: 'Gutscheine',
      wishes: 'Wunschzettel',
      person: 'Person',
    },
    toToday: (app: string) => `${app} – zu Heute`,
    offline: 'Offline – Änderungen werden gespeichert und später übertragen.',
    add: 'Hinzufügen',
    settings: 'Einstellungen',
    parentModeOpen: 'Elternmodus öffnen (Eltern-PIN)',
    viewOf: (who: string) => `Ansicht: ${who}. Person wechseln`,
    everyone: 'Alle',
    hello: (name: string) => `Hallo ${name}`,
    whoForSettings: 'Elternmodus – wer bist du?',
    whoWatches: 'Wer schaut?',
    myAccount: 'Mein Konto',
    enterPin: 'Eltern-PIN eingeben',
    pinWrong: 'Stimmt nicht.',
    pinWrongTries: (n: string) => `Stimmt nicht. Noch ${n} Versuche.`,
    pinWait: 'Bitte kurz warten und nochmal versuchen.',
    cancel: 'Abbrechen',
    backToChoice: 'Zurück zur Auswahl',
    wallPinHint:
      'Eine Person wählen zeigt nur ihre Sachen. Mehr Möglichkeiten: oben auf das Schloss tippen und die Eltern-PIN eingeben. Nach 90 Sekunden ohne Eingabe geht es zurück zu „Alle“.',
    signOut: 'Abmelden',
    update: 'Eine neue Version ist da.',
    later: 'Später',
    refresh: 'Aktualisieren',
    slow: 'Das dauert länger als sonst. Prüf kurz das Internet.',
    reload: 'Neu laden',
    loading: 'Lädt …',
    notFoundTitle: 'Hier ist niemand zu Hause.',
    notFoundText: 'Diese Seite gibt es nicht (mehr).',
    toStart: 'Zur Startseite',
    parentModeLeft: (left: string) => `Elternmodus · noch ${left}`,
    end: 'Beenden',
    failedLater: 'Das hat gerade nicht geklappt. Bitte später nochmal versuchen.',
  },
  en: {
    nav: {
      today: 'Today',
      calendar: 'Calendar',
      tasks: 'Tasks',
      food: 'Food',
      stars: 'Stars',
      fun: 'Fun',
    },
    titles: {
      settings: 'Settings',
      feedback: 'Feedback',
      ideas: 'Ideas',
      vouchers: 'Vouchers',
      wishes: 'Wish list',
      person: 'Person',
    },
    toToday: (app: string) => `${app} – go to Today`,
    offline: 'Offline – changes are saved and sent later.',
    add: 'Add',
    settings: 'Settings',
    parentModeOpen: 'Open parent mode (parent PIN)',
    viewOf: (who: string) => `View: ${who}. Switch person`,
    everyone: 'Everyone',
    hello: (name: string) => `Hello ${name}`,
    whoForSettings: 'Parent mode – who are you?',
    whoWatches: 'Who’s looking?',
    myAccount: 'My account',
    enterPin: 'Enter parent PIN',
    pinWrong: 'That’s not right.',
    pinWrongTries: (n: string) => `That’s not right. ${n} tries left.`,
    pinWait: 'Please wait a moment and try again.',
    cancel: 'Cancel',
    backToChoice: 'Back to the choice',
    wallPinHint:
      'Choosing a person only shows their things. For more, tap the lock at the top and enter the parent PIN. After 90 seconds without input it goes back to “Everyone”.',
    signOut: 'Sign out',
    update: 'A new version is available.',
    later: 'Later',
    refresh: 'Update',
    slow: 'This is taking longer than usual. Please check your internet.',
    reload: 'Reload',
    loading: 'Loading …',
    notFoundTitle: 'Nobody’s home here.',
    notFoundText: 'This page doesn’t exist (any more).',
    toStart: 'Go to the start page',
    parentModeLeft: (left: string) => `Parent mode · ${left} left`,
    end: 'End',
    failedLater: 'That didn’t work just now. Please try again later.',
  },
} as const;

export const appText = APP_TEXT[locale];
